export const RequestMethod = Object.freeze({
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE'
})